import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { InvoicesClientDefaultsPageContext } from "./InvoicesClientDefaultsPageContext";

export const useInvoicesClientDefaultsPageContext = () => {
  const context = useContext(InvoicesClientDefaultsPageContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useInvoicesClientDefaultsPageContext",
      "InvoicesClientDefaultsPageContext"
    );
  }

  return context;
};
